// extracted by mini-css-extract-plugin
export default {"base":"SearchOverview_base__gSzhC","item":"SearchOverview_item__ppxq+","label":"SearchOverview_label__zoI-F"};